import React, { Component } from "react";
import DataStore from "../../../stores/DataStore";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
/**
 * @class
 * Attribut für zum Auswählen einer Datumsangab
 * @name DatePickerAttribute
 *  @implements {Attribute}e
 *
 */
class DatePickerAttribute extends Component {
  onChange(evt) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(evt);
  }

  getValue() {
    const { value } = this.state;
    return value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        attributeOption: {
          LocalizationAdapter = AdapterDateFns,
          locale = "de",
          Picker = DatePicker,
          PickerProps = {},
        },
        attributeModul,
      } = {},
    } = this.props;
    this.id = id;
    attributeModul.holdedAttribute = this;
    const startDate = DataStore.attributeValues[this.id].value
      ? DataStore.attributeValues[this.id].value
      : new Date();
    return (
      // <div />
      <LocalizationProvider locale={locale} utils={LocalizationAdapter} key={`${id}muiPickerUtilsProvider`}>
        <Picker
          disabled={DataStore.attributeValues[this.id].readOnly}
          style={{
            flexGrow: 1,
            marginRight: "5px",
          }}
          shrink
          key={id}
          id={id}
          name={name}
          label={name}
          format="dd/MM/yyyy"
          margin="normal"
          variant="inline"
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          // style={{ float: 'right' }}
          // margin="dense"
          onChange={(evt) => this.onChange(evt)}
          value={startDate}
          {...PickerProps}
        />
      </LocalizationProvider>
      // <div
      // />
    );
  }
}

export default DatePickerAttribute;

// auch hier: Rules? Dependencies?
